import React from 'react'
import cn from 'clsx'
import styled from 'styled-components'
import BuyNowBookLaterIcon from 'components/Luxkit/Icons/custom/BuyNowBookLaterIcon'
import moment from 'moment'
import { DMY_CASUAL_FORMAT, LONG_MONTH_LONG_YEAR } from 'constants/dateFormats'
import { OFFER_TYPE_ALWAYS_ON, OFFER_TYPE_BED_BANK, OFFER_TYPE_HOTEL, OFFER_TYPE_LAST_MINUTE, OFFER_TYPE_TOUR } from 'constants/offer'
import BodyTextBlock from 'components/Luxkit/TextBlocks/BodyTextBlock'

const DateToolTipWrapper = styled.span`
  display: inline-flex;
  &.primary {
    color: ${props => props.theme.palette.brand.primary.normal};
  }
  &.urgent {
    color: ${props => props.theme.palette.messaging.urgency.normalForeground};
  }
`

interface Props {
  size: 'medium' | 'large'
  travelToDate: string;
  type: App.OfferType;
  isCruise?: boolean;
}

function FlashTourTravelUntilMessage(props: Props) {
  const { size, travelToDate, type, isCruise } = props

  const tooltipColourClass = cn({
    primary: type === OFFER_TYPE_TOUR || type === OFFER_TYPE_HOTEL,
    urgent: type === OFFER_TYPE_ALWAYS_ON || type === OFFER_TYPE_BED_BANK || type === OFFER_TYPE_LAST_MINUTE,
  })

  return (
    <BodyTextBlock
      variant={size}
      weight="bold"
      startIcon={<BuyNowBookLaterIcon />}
    >
      {!isCruise && <>
        Travel until{' '}
        <DateToolTipWrapper className={tooltipColourClass}>
          {moment(travelToDate).format(DMY_CASUAL_FORMAT)}
        </DateToolTipWrapper>
      </>}
      {isCruise && <>
        Sailing until{' '}
        <DateToolTipWrapper className={tooltipColourClass}>
          {moment(travelToDate).format(LONG_MONTH_LONG_YEAR)}
        </DateToolTipWrapper>
      </>}
    </BodyTextBlock>
  )
}

FlashTourTravelUntilMessage.defaultProps = {
  size: 'md',
}

export default FlashTourTravelUntilMessage
